import { Helper } from "../core/util/helper";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Grid } from "../core/components/grid";
import { ReportMetaDataHelper, Language } from "./reportMetaDataHelper";
import { Config } from "../core/config/config";
import { Entity } from "../core/components/commonApp";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";

export default class EditTranslations extends React.Component<EditTranslationsProps, EditTranslationsState> {
    private gridOptions: kendo.ui.GridOptions;
    private gridId: string;
    private selected: number;
    private dataChanged: boolean;
    private disabled: boolean;
    private colors = {
        background: "#FE4164",
        font: "#FFFFFF"
    }
    constructor(props: EditTranslationsProps) {
        super(props);
        this.disabled =  this.props.disabled;
        this.gridId = kendo.guid();
        this.selected = null;
        this.dataChanged = false;
        this.initApp();
        this.gridOptions = null;
        this.state = {
            gridData: []
        }
    }

    private update = () => {
        this.dataChanged = true;
        let value = this.props.value;
        for (let i = 0; i < this.state.gridData.length; i++) {
            value[this.state.gridData[i].Key] = this.state.gridData[i].Value;
        }
        Object.keys(value).forEach((key) => {
            if (Helper.isNullOrEmpty(value[key])) {
                delete value[key];
            }
        })



        this.props.onChange(this.props.field, value);
    }

    private onKeyUp = (e: JQuery.KeyUpEvent) => {
        if (Helper.hasValue(this.selected)) {
            const tab = 9;
            const enter = 13;
            //const arrowLeft = 37;
            const arrowUp = 38;
            //const arrowRight = 39;
            const arrowDown = 40;
            const keyCode = e.keyCode;
            let index = -1;
            switch (keyCode) {
                case enter:
                case arrowDown:
                //case tab:
                    index = this.selected + 1;
                    break;
                case arrowUp:
                    index = this.selected - 1;
                    break;
            }
            if (keyCode === arrowDown || keyCode === arrowUp) {
                this.keepValueOfSelectedElement();
                this.move(index);
            } else if (keyCode === enter) {
                this.move(index);
            } else if (keyCode === tab) {
                //this.move(index, () => { e.preventDefault() });
            }
        }
    }

    private move = (index: number, onMove: () => void = null) => {
        let editableCells = $("#" + this.gridId + " tr td:nth-child(2)");
        if (index === -1) {
            index = editableCells.length - 1;
        }
        if (index === editableCells.length) {
            index = 0;
        }
        if (Helper.hasValue(editableCells) && (index > -1) && (index < editableCells.length) && ((this.isGridFocused()) || this.dataChanged)) {
            if (Helper.hasValue(onMove)) {
                onMove();
            }
            this.dataChanged = false;
            let el = editableCells[index];
            el.click();
        }
    }

    private keepValueOfSelectedElement = () => {
        const $focused = $(':focus')
        if (this.isGridFocused()) {//Helper.hasValue($focused) && 
            let gridData = this.state.gridData;
            const value = $focused.val();
            if (Helper.hasValue(value)) {
                gridData[this.selected].Value = value.toString();
                this.setState({ gridData: gridData }, this.update);
            }
        }
    }

    private isGridFocused = (): boolean => {
        let focused = $("#" + this.gridId + " :focus");
        return focused.length > 0;
    }

    private initApp = () => {
        $(document).bind("keyup", this.onKeyUp);
        Promise.all([
            this.loadLanguages(),
            this.loadTranslations()
        ]).then((results) => {
            this.gridOptions = {
                dataSource: {
                    schema: {
                        model: {
                            id: "Id",
                            fields: {
                                Language: { editable: false },
                                Value: { editable: !this.disabled }
                            }
                        }
                    }
                },
                sortable: true,
                pageable: true,
                groupable: false,
                filterable: false,
                selectable: true,
                resizable: true,
                scrollable: true,
                editable: true,
                save: (e: kendo.ui.GridSaveEvent) => {
                    let item = (e.model) as any;
                    item.Value = e.values["Value"];
                    this.onGridValueChange(item);
                },
                columns: [
                    {
                        field: "Language",
                        title: results[1]["Field.Adresse.language"]
                    },
                    {
                        field: "Value",
                        title: results[1]["Parts.TranslationLink.LabelTranslation"],
                        editable: (data) => {
                            this.selected = this.state.gridData.findIndex(f => f.Key == data["Key"]);
                            return true;
                        }
                    }
                ]
            };
            const ignoredKeys = [
                "_events", "_handlers", "uid", "parent"
            ];
            const keys = Object.keys(this.props.value).filter(f1 => ignoredKeys.findIndex(f2 => f1 === f2) === -1);
            let data: GridData[] = results[0].map((item) => {
                let value: string = null;
                let exist = keys.findIndex(f => f.toLowerCase() === item.Code.toLowerCase()) > -1;
                if (exist) {
                    value = this.props.value[item.Code.toLowerCase()];
                }
                return {
                    Key: item.Code,
                    Value: value,
                    Language: item.Displaynameen + " (" + item.Displaynamenative + ")",
                    Colorize: false
                };
            });
            if (this.disabled) {
                keys.filter(f1 => data.findIndex(f2 => f2.Key === f1) === -1).map((key) => {
                    let value: string = this.props.value[key];
                    data.push({
                        Colorize: true,
                        Key: key,
                        Language: key,
                        Value: value
                    });
                });
            }
            this.setState({ gridData: data })
        })
    }

    private loadLanguages = (): Promise<Language[]> => {
        return new Promise<Language[]>((resolve) => {
            HTTPService.get<JsonResultClass<Language[]>>("EditIndividualFields/GetLanguages").then((result) => {
                if (result.Code == 0) {
                    let data = result.Data;
                    if (Helper.hasValue(this.props.ignoredLanguages)) {
                        data = data.filter(l1 => this.props.ignoredLanguages.findIndex(l2 => l1.Code == l2) === -1);
                    }
                    resolve(data);
                } else {
                    resolve([]);
                }
            });
        })
    }

    private loadTranslations = (): Promise<StringKeyDictionary<string>> => {
        return new Promise<StringKeyDictionary<string>>((resolve) => {
            const key = `translationGrid_translations_${Config.user.languageId}`;
            let result = Helper.loadDataFromStorage(key);
            if (Helper.hasValue(result)) {
                resolve(result);
            } else {
                Helper.getTranslations(["Field.Adresse.language", "Parts.TranslationLink.LabelTranslation"]).then((result) => {
                    if (result.Code == 0) {
                        Helper.saveDataToStorage(key, result.Data, false);
                        resolve(result.Data)
                    }
                })
            }
        })
    } 

    private createGrid = () => {
        return (
            <div className="flex-container" id={this.gridId}>
                <style>
                    {
                        `.k-input-solid, .k-input-solid:focus-within {
                            background-color: white;
                        }`
                    }
                </style>
                <Grid
                    data={this.state.gridData}
                    options={this.gridOptions}
                    id="reportMetaDataTranslations"
                    onDataBound={this.handleDataBound}
                />
            </div>
        );
    }

    private handleDataBound = (e) => {
        let data = e.sender.dataSource.view();
        for (var i = 0; i < data.length; i++) {
            if (data[i].Colorize) {
                let row = e.sender.tbody.find("tr[data-uid='" + data[i].uid + "']");
                let cell = $("td", row);
                cell.css("background-color", this.colors.background);
                cell.css("color", this.colors.font);
            }
        }
    }

    private onGridValueChange = (dataItem: GridData) => {
        let index = this.state.gridData.findIndex(f => f.Key === dataItem.Key);
        let gridData = this.state.gridData;
        gridData[index].Value = dataItem.Value;
        this.setState({ gridData: gridData }, this.update)
    }

    componentDidUpdate(prevProps) {
        const disabled =  this.props.disabled;
        if (this.disabled !== disabled) {
            this.disabled = disabled;
            this.initApp();
        }
    }

    componentWillUnmount() {
        $(document).unbind("keyup", this.onKeyUp);
    }

    render() {
        const grid = Helper.hasValue(this.gridOptions) ? this.createGrid() : null;
        return <>
            {grid}
        </>;
    }
}

export interface EditTranslationsProps {
    value: {};
    entity: Entity;
    onChange: (field, value: {}) => void;
    field: any;
    disabled: boolean;
    context: {
        translations: {}
    },
    ignoredLanguages?: string[]
}

interface EditTranslationsState {
    gridData: GridData[];
}

interface GridData {
    Key: string; //langugageCode
    Value: string;
    Language: string;
    Colorize: boolean;
}